import 'whatwg-fetch';
import { getUrlWithVariant, ProductForm } from '@shopify/theme-product-form';

import SimpleGallery from '../components/simple-gallery/SimpleGallery';
import imageZoom from '../components/layout/imageZoom';
import Cart from '../components/cart/Cart';
import { theme } from '../constants/defaults';
import { formatMoney } from '../utils/product';

export default class Product {
  constructor() {
    this.cart = Cart.getInstance();
    this.gallery = new SimpleGallery(document.querySelector('.js-simple-gallery'));

    this.productFormElement = document.querySelector('[data-product-form]');
    this.noteElement = this.productFormElement.querySelector('.note');
    this.addToCartTriggers = [...document.querySelectorAll('.js-add-to-cart')];

    this.initProductForm();
    this.addToCart();
    imageZoom();

    // Listen for changes done in the Theme Editor
    document.addEventListener('shopify:section:load', event => {
      if (event.detail.sectionId === 'product-recommendations') {
        this.productRecommendations();
      }
    });

    this.productRecommendations();
  }

  initProductForm() {
    const { productHandle } = this.productFormElement.dataset;
    fetch(`/products/${productHandle}.js`)
      .then(response => {
        return response.json();
      })
      .then(productJSON => {
        this.productForm = new ProductForm(this.productFormElement, productJSON, {
          onOptionChange: e => this.onOptionChange(e),
          onFormSubmit: e => this.onFormSubmit(e),
        });
      });
  }

  enableAddToCartTriggers() {
    this.addToCartTriggers.forEach(trigger => {
      trigger.removeAttribute('disabled');
      // eslint-disable-next-line no-param-reassign
      trigger.innerHTML = theme.strings.addToCart;
    });
  }

  disableAddToCartTriggers() {
    this.addToCartTriggers.forEach(trigger => {
      trigger.setAttribute('disabled', 'disabled');
      // eslint-disable-next-line no-param-reassign
      trigger.innerHTML = theme.strings.soldOut;
    });
  }

  onOptionChange(event) {
    const { variant } = event.dataset;
    this.hideNoteElement();

    // Skip when there is no variant selected
    if (!variant) {
      return;
    }

    if (variant.featured_image) {
      this.gallery.element
        .querySelector(`[data-variant-image-id="${variant.featured_image.id}"]`)
        .click();
    }

    if (variant.available) {
      this.enableAddToCartTriggers();
    } else {
      this.disableAddToCartTriggers();
    }

    [...document.querySelectorAll('.js-product-price')].forEach(priceEl => {
      priceEl.innerHTML = formatMoney(variant.price); // eslint-disable-line
    });

    [...document.querySelectorAll('.js-product-compare-price')].forEach(comparePriceEl => {
      if (variant.compare_at_price > variant.price) {
        comparePriceEl.innerHTML = formatMoney(variant.compare_at_price); // eslint-disable-line
        comparePriceEl.classList.remove('hide');
      } else {
        comparePriceEl.innerHTML = ''; // eslint-disable-line
        comparePriceEl.classList.add('hide');
      }
    });

    const url = getUrlWithVariant(window.location.href, variant.id);
    window.history.replaceState({ path: url }, '', url);
  }

  hideNoteElement() {
    this.noteElement.classList.add('hide');
    this.noteElement.classList.remove('note--success');
    this.noteElement.classList.remove('note--error');
    this.noteElement.innerHTML = '';
  }

  showNoteElement(message, isSuccess) {
    if (isSuccess) {
      this.noteElement.classList.add('note--success');
    } else {
      this.noteElement.classList.add('note--error');
    }

    this.noteElement.innerHTML = message;
    this.noteElement.classList.remove('hide');
  }

  onFormSubmit(e) {
    e.preventDefault();
    const { variant, quantity, properties } = e.dataset;
    this.cart.addItem(variant.id, { quantity, properties });
  }

  addToCart() {
    const addToCartTrigger = this.productFormElement.querySelector('.js-add-to-cart');

    this.cart.on('adding', () => {
      addToCartTrigger.classList.add('loading');
      this.hideNoteElement();
    });

    this.cart.on('added', () => {
      addToCartTrigger.classList.remove('loading');
      this.showNoteElement(theme.strings.successAddToCart, true);
    });

    this.cart.on('error_add_item', error => {
      addToCartTrigger.classList.remove('loading');
      if (error.status === 422) {
        this.showNoteElement(error.description, false);
      } else {
        this.showNoteElement(theme.strings.errorAddToCart, false);
      }
    });
  }

  productRecommendations() {
    const container = document.querySelector('.js-product-recommendations');
    if (!container) {
      return;
    }

    const { baseUrl, productId, sectionId, limit } = container.dataset;
    const recommendationsSectionUrl = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`;

    fetch(recommendationsSectionUrl)
      .then(res => res.text())
      .then(section => {
        container.innerHTML = section;
      });
  }
}
